<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="weibu" style="overflow: hidden;min-width: 972px;">
    <div style="margin: 0 auto;min-width: 952px;" class="weibuWidth" v-if="webInfo">
      <div style="padding:0 20px">
        <div>
          <div style="float: left; margin-top: 50px">
            <div class="bottom-logo" >
              <img v-if="webInfo.web_bottom_logo" :src="webInfo.web_bottom_logo" alt="" />
            </div>
            <p class="tengface">{{ webInfo.web_company_name }}</p>
            <p class="tengface" style="font-size: 16px; margin-top: 7px;" v-if="webInfo.web_text_sm">{{ webInfo.web_text_sm }}</p>
            <a v-if="webInfo.web_about_text_1" class="hezuo"  :href="webInfo.web_about_link_1" 
               style="margin-top: 16px;display: block;text-decoration:none;">{{ webInfo.web_about_text_1 }}</a>
            <a v-if="webInfo.web_about_text_2" class="hezuo" :href="webInfo.web_about_link_2" 
               style="margin-top: 18px;display: block;text-decoration:none;">{{ webInfo.web_about_text_2 }}</a>
               <p v-if="is_show == '2'" class="hezuo" style="margin-top: 18px;display: block;text-decoration:none;" @click="dialogVisible = true">
                查看公司信息
              </p>
          </div>
          <div style="float: right; margin-top: 50px;">
            <div style="float: left">
              <template v-if="webInfo.web_contact_number">
                <p class="hezuo">联系我们</p>
                <p class="tengface" style="font-size: 28px" >{{ webInfo.web_contact_number }}</p>
              </template>
              <p class="hezuo" style="margin-top: 26px">
                {{ webInfo.web_address }}
              </p>
              <p class="hezuo" style="margin-top: 18px">
                {{ webInfo.web_mail }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="tengfaceyi">
        <p class="suoyou">Copyright © 2021 {{ webInfo.web_company_name }} 版权所有  {{ webInfo.web_record_number }}</p>
      </div>
    </div>
    <el-dialog
    title="安全验证"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose">
    <div class="yanzhengma">
       <div class="yanzhengmade">
          <input class="shuruyanz" type="text" v-model="inputCode" placeholder="请输入下图验证码，不区分大小写">
          <div style="margin-top: 10px;display: flex;">
              <!--验证码组件-->
              <div style="margin-left: 120px;"><VerifyStyle :identifyCode="identifyCode"></VerifyStyle></div>
              <div><i class="el-icon-refresh-left" @click="refreshCode()" style="font-size: 24px;margin-left: 15px;margin-top: 17px;"></i></div>
          </div>
          <button class="tijiaoanniu" type="primary" @click="getSubmitData()">提交</button>
       </div>
    </div>
  </el-dialog>
  <el-dialog
    title="公司信息"
    :visible.sync="dialogVisiblelist"
    width="600px"
    :before-close="handleClose">
     <div style="height: 200px;">
      <div>
       <p class="qiyemc">企业名称</p>
       <p class="gongming">{{org_name}}</p>
     </div>
     <div style="clear:both;"></div>
     <div style="margin-top: 40px;">
       <p style="margin-top: 35px;" class="qiyemc">营业执照</p>
       <p class="gongming" style="margin-top: 35px;">点图放大</p>
       <div class="demo-image__preview gongming">
        <el-image 
          style="width: 100px; height: 100px"
          :src="url" 
          :preview-src-list="srcList">
        </el-image>
      </div>
     </div>
     </div>
  </el-dialog>
  </div>
</template>

<script>
import VerifyStyle from "./VerifyStyle.vue";
import { mapState } from 'vuex'
export default {
  components: { VerifyStyle },
  data() {
    return {
      dialogVisible: false,
      identifyCodeType: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ", //定义验证类型 1.数字 2.字母
      identifyCode: "",
      inputCode: "", //text框输入的验证码
      dialogVisiblelist: false,
      url: '',
      srcList: [],
      is_show: '',
      org_name: ''

    }
  },
  computed: {
    ...mapState(['webInfo', 'org_id']),
  },
  created() {
    this.refreshCode()
    this.storedata()
    this.is_show = localStorage.getItem('tengface_is_show')
  },
  methods: {
    storedata() {
      // 获取商户营业执照
      const data = {
        uid: localStorage.getItem('tengface_org_id')
      }
      this.$liveApi.post('/liveapi/api/store_data', data)
      .then(res=>{
        if(res.data.code == 200){
          this.url = res.data.data.business_img
          this.org_name = res.data.data.org_name
          this.srcList.push(this.url)
        }
      })
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      //验证码规则
    getSubmitData() {
      if (this.inputCode == "") {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return;
      }
      let num = this.inputCode.toUpperCase()
      if (this.identifyCode !== num) {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: '请输入正确验证码',
          type: 'error'
        });
        return;
      } else {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: '验证成功',
          type: 'success'
        });
        this.dialogVisible = false
        this.dialogVisiblelist = true
        // this.$router.push({'path':'/Informationpage'});
      }
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //初始化验证码
    refreshCode() {
      this.identifyCode = ""; //输入框置空
      this.makeCode(this.identifyCodeType, 4); //验证码长度为4
    },
    //随机切换验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodeType[
            this.randomNum(0, this.identifyCodeType.length)
          ];
      }
    //   console.log(this.identifyCode);
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.qiyemc {
  float: left;
  margin-left: 20px;
}
.gongming {
  float:right;
  margin-right: 20px;
}
.tijiaoanniu {
    width: 130px;
    height: 30px;
    background: #0066FF;
    border: none;
    color: #fff;
    border-radius: 20px;
    margin-top: 20px;
}
.shuruyanz {
    width: 220px;
    height: 40px;
}
.yanzhengmade {
    text-align: center;
    margin-top: 20px;
}
.anquan p {
    color: #000;
    font-weight: 600;
}
  .yanzhengma { 
    height: 230px;
  }
/* 尾部 */
.weibu {
  width: 100%;
  height: 258px;
  opacity: 1;
  background: #101115;
}
.tengface {
  opacity: 1;
  font-size: 24px;
  font-family: baotuculangti;
  text-align: left;
  color: #82858a;
}
.hezuo {
  opacity: 1;
  font-size: 14px;
  font-family: HiraginoSansGB, HiraginoSansGB-W3;
  font-weight: W3;
  text-align: left;
  color: #82858a;
}
.tengfaceyi {
  width: 100%;
  height: 49px;
  opacity: 1;
  background: #101115;
  padding-top: 35px;
  overflow: hidden;
  margin: 0 auto;
}
.suoyou {
  opacity: 1;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: center;
  color: #82858a;
  line-height: 19px;
}
.xuanfu {
  position: fixed;
  z-index: 3;
  width: 60px;
  height: 240px;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #e5e8eb;
  right: 50px;
  top: 113px;
}
.weixin {
  height: 66px;
  width: 47px;
  border-bottom: 1px solid #e5e8eb;
  text-align: center;
  margin: 0 auto;
  margin-top: 15px;
}
.weixinyi {
  height: 66px;
  width: 47px;
  text-align: center;
  margin: 0 auto;
  margin-top: 15px;
}
.lianxi {
  opacity: 1;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  text-align: center;
  color: #20242f;
}
.bottom-logo {
  width: 96px;
  img {
    width: 100%;
  }
}
</style>
